'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('speechtypees', {
        url: '/speechtypees',
        template: '<speechtypees></speechtypees>'
    });
}



// WEBPACK FOOTER //
// ./client/app/speechtypees/speechtypees.routes.js